/**
 * 프로젝트 및 팀 공통 카테고리 정의
 * 프로젝트 대분류/소분류와 팀 주직무/전문분야를 통일
 */

export interface Category {
  mainCategory: string
  subCategories: readonly string[]
}

export const PROJECT_CATEGORIES: readonly Category[] = [
  {
    mainCategory: "웹 개발",
    subCategories: [
      "프론트엔드 개발",
      "백엔드 개발",
      "풀스택 개발",
      "API 개발 및 통합",
      "웹 퍼블리싱",
      "CMS/쇼핑몰 구축"
    ]
  },
  {
    mainCategory: "모바일 앱 개발",
    subCategories: [
      "iOS 앱 개발",
      "안드로이드 앱 개발",
      "크로스플랫폼 앱 개발 (Flutter/RN)",
      "하이브리드 앱 개발"
    ]
  },
  {
    mainCategory: "소프트웨어/솔루션",
    subCategories: [
      "데스크탑 앱(Windows/Mac)",
      "임베디드/IoT",
      "RPA/매크로",
      "플러그인/확장프로그램"
    ]
  },
  {
    mainCategory: "게임/VR/AR",
    subCategories: [
      "모바일/PC 게임",
      "VR/AR/메타버스",
      "유니티(Unity)/언리얼(Unreal)"
    ]
  },
  {
    mainCategory: "인공지능(AI)/데이터",
    subCategories: [
      "AI 챗봇/에이전트",
      "데이터 분석 및 모델링",
      "컴퓨터 비전/영상처리",
      "자연어 처리(NLP)",
      "데이터 엔지니어링",
      "추천 시스템"
    ]
  },
  {
    mainCategory: "블록체인",
    subCategories: [
      "스마트 컨트랙트",
      "DApp 개발",
      "NFT/토큰 발행",
      "거래소/지갑 개발"
    ]
  },
  {
    mainCategory: "인프라/클라우드/보안",
    subCategories: [
      "클라우드 구축(AWS/Azure/GCP)",
      "데브옵스(DevOps)",
      "CI/CD 파이프라인",
      "서버/네트워크 보안",
      "시스템 엔지니어링"
    ]
  },
  {
    mainCategory: "기획/PM",
    subCategories: [
      "서비스 기획(화면설계)",
      "웹/앱 기획",
      "PM/PO",
      "프로젝트 관리",
      "사업계획/제안서"
    ]
  },
  {
    mainCategory: "디자인/미디어",
    subCategories: [
      "웹/앱 디자인(UI/UX)",
      "그래픽/브랜딩",
      "3D/모션그래픽",
      "상세페이지/배너",
      "영상 편집/제작"
    ]
  },
  {
    mainCategory: "마케팅/기타",
    subCategories: [
      "검색최적화(SEO)",
      "퍼포먼스 마케팅",
      "바이럴/SNS 마케팅",
      "번역/통역"
    ]
  }
] as const

// 대분류 목록
export const MAIN_CATEGORIES = PROJECT_CATEGORIES.map(c => ({ value: c.mainCategory, label: c.mainCategory })) as readonly { value: string, label: string }[]

// 소분류를 대분류로 매핑
export const SUB_CATEGORY_TO_MAIN_CATEGORY: Record<string, string> = PROJECT_CATEGORIES.reduce(
  (acc, category) => {
    category.subCategories.forEach(sub => {
      acc[sub] = category.mainCategory
    })
    return acc
  },
  {} as Record<string, string>
)

// 대분류별 소분류 옵션
export const SUB_CATEGORIES_BY_MAIN: Record<string, readonly string[]> = PROJECT_CATEGORIES.reduce(
  (acc, category) => {
    acc[category.mainCategory] = category.subCategories
    return acc
  },
  {} as Record<string, readonly string[]>
)

